// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import {
//   getBookingPolicies,
//   getBookingPolicyById,
//   createBookingPolicy,
//   updateBookingPolicy,
//   deleteBookingPolicy,
//   toggleBookingPolicyStatus,
//   getFormattedPolicyText,
// } from '../../Services/Operations/ProductAPI';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Policy Name</th>
//           <th>Cancellation Hours</th>
//           <th>Child Age Limit</th>
//           <th>Refund %</th>
//           <th>Applicable For</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const BookingPolicyManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [policies, setPolicies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingPolicy, setEditingPolicy] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingPolicy, setViewingPolicy] = useState(null);
//   const [creatingNew, setCreatingNew] = useState(false);
//   const [newPolicyForm, setNewPolicyForm] = useState({
//     policyName: '',
//     cancellationHours: 4,
//     childAgeLimit: 5,
//     requiredIdProof: true,
//     refundPercentage: 100,
//     applicableFor: ['all'],
//     description: '',
//     termsAndConditions: '',
//     isActive: true,
//     policyType: 'standard'
//   });
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const [formattedText, setFormattedText] = useState(null);
//   const [showFormattedText, setShowFormattedText] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalPolicies, setTotalPolicies] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchPolicies();
//     }, 500);
//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const extractHoursFromText = (text) => {
//     if (!text) return 4;
//     const match = text.match(/(\d+)\s*hours?/i);
//     return match ? parseInt(match[1]) : 4;
//   };

//   const extractAgeFromText = (text) => {
//     if (!text) return 5;
//     const match = text.match(/above\s*(\d+)\s*years?/i);
//     return match ? parseInt(match[1]) : 5;
//   };

//   const extractRefundFromText = (text) => {
//     if (!text) return 100;
//     const match = text.match(/(\d+)%/);
//     return match ? parseInt(match[1]) : 100;
//   };

//   const fetchPolicies = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       const response = await getBookingPolicies(token, currentPage, pageSize, searchTerm);

//       if (response && response.data) {
//         const transformedPolicies = response.data.map((policy, index) => {
//           const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
          
//           return {
//             id: policy.id || policy._id,
//             serialNo: getSequentialNumber(index),
//             policyName: policy.policyName || 'Untitled Policy',
//             cancellationHours: policy.cancellationHours !== undefined && policy.cancellationHours !== null 
//               ? policy.cancellationHours 
//               : extractHoursFromText(policy.cancellationPolicy) || 4,
//             childAgeLimit: policy.childAgeLimit !== undefined && policy.childAgeLimit !== null
//               ? policy.childAgeLimit
//               : extractAgeFromText(policy.childTicketPolicy) || 5,
//             refundPercentage: policy.refundPercentage !== undefined && policy.refundPercentage !== null
//               ? policy.refundPercentage
//               : extractRefundFromText(policy.refundPolicy) || 100,
//             applicableFor: policy.applicableFor || ['all'],
//             isActive: policy.isActive !== undefined ? policy.isActive : true,
//             status: policy.isActive ? 'Active' : 'Inactive',
//             description: policy.description || '',
//             termsAndConditions: policy.termsAndConditions || '',
//             requiredIdProof: policy.idProofRequirement || 'Valid ID proof required',
//             createdAt: policy.createdAt || new Date().toISOString(),
//             updatedAt: policy.updatedAt || new Date().toISOString(),
//             cancellationPolicy: policy.cancellationPolicy || `Cancellation allowed up to ${policy.cancellationHours || 4} hours before departure`,
//             refundPolicy: policy.refundPolicy || `${policy.refundPercentage || 100}% refund applicable on valid cancellations`,
//             childTicketPolicy: policy.childTicketPolicy || `Children above ${policy.childAgeLimit || 5} years need a full ticket`,
//             idProofRequirementText: policy.idProofRequirement || 'Valid ID proof required for all passengers',
//             isInstant: isInstant
//           };
//         });

//         setPolicies(transformedPolicies);
//         setTotalPages(response.totalPages || 1);
//         setTotalPolicies(response.total || response.data.length);
//       }
//     } catch (err) {
//       setError('Failed to fetch booking policies.');
//       console.error('Error fetching policies:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewPolicy = async (policyId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getBookingPolicyById(policyId, token);
      
//       if (response.success) {
//         const policy = response.data;
//         const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
        
//         setViewingPolicy({
//           id: policy.id || policy._id,
//           policyName: policy.policyName || 'Untitled Policy',
//           cancellationPolicy: isInstant 
//             ? 'Instant Ticket Can Not Be Cancel' 
//             : (policy.cancellationPolicy || `Cancellation allowed up to ${policy.cancellationHours || 4} hours before departure`),
//           childTicketPolicy: policy.childTicketPolicy || `Children above ${policy.childAgeLimit || 5} years need a full ticket`,
//           idProofRequirement: policy.idProofRequirement || 'Valid ID proof required for all passengers',
//           refundPercentage: policy.refundPercentage !== undefined && policy.refundPercentage !== null
//             ? policy.refundPercentage
//             : extractRefundFromText(policy.refundPolicy) || 100,
//           applicableFor: policy.applicableFor || ['all'],
//           description: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.description || ''),
//           termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.termsAndConditions || ''),
//           isActive: policy.isActive !== undefined ? policy.isActive : true,
//           isInstant: isInstant,
//           createdAt: policy.createdAt ? new Date(policy.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }) : 'N/A',
//           updatedAt: policy.updatedAt ? new Date(policy.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }) : 'N/A'
//         });
//       } else {
//         setError('Failed to fetch policy details.');
//       }
//     } catch (err) {
//       console.error('Error fetching policy details:', err);
//       setError('Failed to fetch policy details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleViewFormattedText = async (policyId) => {
//     try {
//       setIsFetchingDetails(true);
//       const response = await getFormattedPolicyText(policyId, token);
//       if (response.success) {
//         setFormattedText(response.data.formattedText);
//         setShowFormattedText(true);
//       }
//     } catch (err) {
//       console.error('Error fetching formatted text:', err);
//       setError('Failed to fetch formatted policy text.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditPolicy = async (policyId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getBookingPolicyById(policyId, token);
      
//       if (response.success) {
//         const policy = response.data;
//         const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
        
//         setEditingPolicy(policy.id || policy._id);
//         setEditForm({
//           policyName: policy.policyName || '',
//           cancellationHours: isInstant ? 0 : (policy.cancellationHours !== undefined && policy.cancellationHours !== null
//             ? policy.cancellationHours
//             : extractHoursFromText(policy.cancellationPolicy) || 4),
//           childAgeLimit: policy.childAgeLimit !== undefined && policy.childAgeLimit !== null
//             ? policy.childAgeLimit
//             : extractAgeFromText(policy.childTicketPolicy) || 5,
//           requiredIdProof: policy.idProofRequirement ? policy.idProofRequirement.includes('required') : true,
//           refundPercentage: isInstant ? 0 : (policy.refundPercentage !== undefined && policy.refundPercentage !== null
//             ? policy.refundPercentage
//             : extractRefundFromText(policy.refundPolicy) || 100),
//           applicableFor: policy.applicableFor || ['all'],
//           description: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.description || ''),
//           termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.termsAndConditions || ''),
//           isActive: policy.isActive !== undefined ? policy.isActive : true,
//           isInstant: isInstant
//         });
//       } else {
//         setError('Failed to fetch policy details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching policy details for editing:', err);
//       setError('Failed to fetch policy details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       const isInstant = editForm.policyName && editForm.policyName.toLowerCase().includes('instant');
      
//       const updateData = {
//         policyName: editForm.policyName,
//         cancellationHours: isInstant ? 0 : parseInt(editForm.cancellationHours) || 0,
//         childAgeLimit: parseInt(editForm.childAgeLimit) || 5,
//         requiredIdProof: editForm.requiredIdProof,
//         refundPercentage: isInstant ? 0 : parseInt(editForm.refundPercentage) || 0,
//         applicableFor: editForm.applicableFor,
//         description: isInstant ? 'Instant Ticket Can Not Be Cancel' : editForm.description,
//         termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : editForm.termsAndConditions,
//         isActive: editForm.isActive
//       };

//       const response = await updateBookingPolicy(editingPolicy, updateData, token);
      
//       if (response.success) {
//         setPolicies(prevPolicies =>
//           prevPolicies.map(policy =>
//             policy.id === editingPolicy ? {
//               ...policy,
//               policyName: response.data.policyName,
//               cancellationHours: response.data.cancellationHours,
//               childAgeLimit: response.data.childAgeLimit,
//               refundPercentage: response.data.refundPercentage,
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive,
//               isInstant: isInstant
//             } : policy
//           )
//         );
//         setEditingPolicy(null);
//         setEditForm({});
//         alert('Booking policy updated successfully!');
//         fetchPolicies();
//       } else {
//         setError(response.message || 'Failed to update policy.');
//       }
//     } catch (err) {
//       console.error('Error updating policy:', err);
//       setError(err.response?.data?.message || 'Failed to update policy.');
//       alert('Failed to update policy. Please try again.');
//     }
//   };

//   const handleCreatePolicy = async () => {
//     try {
//       setError(null);
      
//       const isInstant = newPolicyForm.policyType === 'instant';
      
//       const createData = {
//         policyName: isInstant ? 'Instant Bus Booking Policy' : newPolicyForm.policyName,
//         cancellationHours: isInstant ? 0 : parseInt(newPolicyForm.cancellationHours) || 0,
//         childAgeLimit: parseInt(newPolicyForm.childAgeLimit) || 5,
//         requiredIdProof: newPolicyForm.requiredIdProof,
//         refundPercentage: isInstant ? 0 : parseInt(newPolicyForm.refundPercentage) || 0,
//         applicableFor: newPolicyForm.applicableFor,
//         description: isInstant ? 'Instant Ticket Can Not Be Cancel' : newPolicyForm.description,
//         termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : newPolicyForm.termsAndConditions,
//         isActive: newPolicyForm.isActive
//       };

//       const response = await createBookingPolicy(createData, token);
      
//       if (response.success) {
//         setCreatingNew(false);
//         setNewPolicyForm({
//           policyName: '',
//           cancellationHours: 4,
//           childAgeLimit: 5,
//           requiredIdProof: true,
//           refundPercentage: 100,
//           applicableFor: ['all'],
//           description: '',
//           termsAndConditions: '',
//           isActive: true,
//           policyType: 'standard'
//         });
//         alert('Booking policy created successfully!');
//         fetchPolicies();
//       } else {
//         setError(response.message || 'Failed to create policy.');
//       }
//     } catch (err) {
//       console.error('Error creating policy:', err);
//       setError(err.response?.data?.message || 'Failed to create policy.');
//       alert('Failed to create policy. Please try again.');
//     }
//   };

//   const handleToggleStatus = async (policyId, currentStatus) => {
//     if (window.confirm(`Are you sure you want to ${currentStatus ? 'deactivate' : 'activate'} this policy?`)) {
//       try {
//         const response = await toggleBookingPolicyStatus(policyId, token);
//         if (response.success) {
//           alert(`Policy ${response.message}`);
//           fetchPolicies();
//         }
//       } catch (err) {
//         console.error('Error toggling policy status:', err);
//         alert('Failed to update policy status.');
//       }
//     }
//   };

//   const handleDeletePolicy = async (policyId) => {
//     if (window.confirm('Are you sure you want to delete this policy?')) {
//       try {
//         const response = await deleteBookingPolicy(policyId, token);
//         if (response.success) {
//           alert('Policy deleted successfully!');
//           fetchPolicies();
//         }
//       } catch (err) {
//         console.error('Error deleting policy:', err);
//         alert('Failed to delete policy.');
//       }
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingPolicy(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleCancelCreate = () => {
//     setCreatingNew(false);
//     setNewPolicyForm({
//       policyName: '',
//       cancellationHours: 4,
//       childAgeLimit: 5,
//       requiredIdProof: true,
//       refundPercentage: 100,
//       applicableFor: ['all'],
//       description: '',
//       termsAndConditions: '',
//       isActive: true,
//       policyType: 'standard'
//     });
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleNewPolicyChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewPolicyForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handlePolicyTypeChange = (e) => {
//     const value = e.target.value;
//     const isInstant = value === 'instant';
    
//     setNewPolicyForm(prev => ({
//       ...prev,
//       policyType: value,
//       policyName: isInstant ? 'Instant Bus Booking Policy' : prev.policyName,
//       cancellationHours: isInstant ? 0 : prev.cancellationHours,
//       refundPercentage: isInstant ? 0 : prev.refundPercentage,
//       description: isInstant ? 'Instant Ticket Can Not Be Cancel' : prev.description,
//       termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : prev.termsAndConditions
//     }));
//   };

//   const handleApplicableForChange = (e) => {
//     const options = e.target.options;
//     const selected = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         selected.push(options[i].value);
//       }
//     }
//     setNewPolicyForm(prev => ({
//       ...prev,
//       applicableFor: selected
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingPolicy(null);
//     setShowFormattedText(false);
//     setFormattedText(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     fetchPolicies();
//   };

//   const handleExportCSV = () => {
//     if (policies.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['No.', 'Policy Name', 'Cancellation Hours', 'Child Age Limit', 'Refund %', 'Applicable For', 'Status', 'Created At'];
//     const csvData = policies.map(policy => [
//       policy.serialNo,
//       policy.policyName,
//       policy.isInstant ? 'No Cancellation' : `${policy.cancellationHours} hours`,
//       `Above ${policy.childAgeLimit} years`,
//       policy.isInstant ? '0%' : `${policy.refundPercentage}%`,
//       policy.applicableFor.join(', '),
//       policy.status,
//       new Date(policy.createdAt).toLocaleDateString()
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `booking-policies-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   if (loading && policies.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>
//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>
//         <SkeletonTable />
//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Booking Policy Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search policies by name..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setCreatingNew(true)}>
//             + Add Policy
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Policies</h3>
//           <p>{totalPolicies}</p>
//           <span>All booking policies</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Policies</h3>
//           <p>{policies.filter(p => p.status === 'Active').length}</p>
//           <span>Active policies</span>
//         </div>
//         <div className="stat-card">
//           <h3>Inactive Policies</h3>
//           <p>{policies.filter(p => p.status === 'Inactive').length}</p>
//           <span>Inactive policies</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{policies.length}</p>
//           <span>policies found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Policy Name</th>
//               <th>Cancellation Hours</th>
//               <th>Child Age Limit</th>
//               <th>Refund %</th>
//               <th>Applicable For</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {policies.length > 0 ? (
//               policies.map(policy => (
//                 <tr key={policy.id}>
//                   <td>{policy.serialNo}</td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <input
//                         type="text"
//                         name="policyName"
//                         value={editForm.policyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Policy Name"
//                       />
//                     ) : (
//                       <strong>
//                         {policy.policyName}
//                         {policy.isInstant && (
//                           <span style={{ 
//                             display: 'inline-block', 
//                             marginLeft: '8px', 
//                             fontSize: '10px', 
//                             background: '#ff6b6b', 
//                             color: 'white', 
//                             padding: '2px 8px', 
//                             borderRadius: '12px',
//                             fontWeight: 'normal'
//                           }}>
//                             No Cancellation
//                           </span>
//                         )}
//                       </strong>
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <input
//                         type="number"
//                         name="cancellationHours"
//                         value={editForm.cancellationHours || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Hours"
//                         min="0"
//                         disabled={editForm.isInstant}
//                       />
//                     ) : (
//                       <span>
//                         {policy.isInstant ? (
//                           <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
//                             No Cancellation
//                           </span>
//                         ) : (
//                           `${policy.cancellationHours} hours`
//                         )}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <input
//                         type="number"
//                         name="childAgeLimit"
//                         value={editForm.childAgeLimit || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Age"
//                         min="0"
//                       />
//                     ) : (
//                       `Above ${policy.childAgeLimit} years`
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <input
//                         type="number"
//                         name="refundPercentage"
//                         value={editForm.refundPercentage || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="%"
//                         min="0"
//                         max="100"
//                         disabled={editForm.isInstant}
//                       />
//                     ) : (
//                       <span>
//                         {policy.isInstant ? (
//                           <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
//                             0% (No Refund)
//                           </span>
//                         ) : (
//                           `${policy.refundPercentage}%`
//                         )}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <select
//                         multiple
//                         name="applicableFor"
//                         value={editForm.applicableFor || ['all']}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                       >
//                         <option value="all">All</option>
//                         <option value="ac">AC</option>
//                         <option value="non-ac">Non-AC</option>
//                         <option value="sleeper">Sleeper</option>
//                         <option value="seater">Seater</option>
//                       </select>
//                     ) : (
//                       policy.applicableFor?.join(', ') || 'All'
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <label className="checkbox-label">
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={editForm.isActive || false}
//                           onChange={handleInputChange}
//                         />
//                         <span className="checkbox-text">
//                           {editForm.isActive ? 'Active' : 'Inactive'}
//                         </span>
//                       </label>
//                     ) : (
//                       <span className={`status-badge ${policy.status ? policy.status.toLowerCase() : 'inactive'}`}>
//                         {policy.status}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {editingPolicy === policy.id ? (
//                       <div className="edit-actions">
//                         <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                           Save
//                         </button>
//                         <button className="action-btn cancel" onClick={handleCancelEdit}>
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewPolicy(policy.id)}
//                           title="View Details"
//                         >
//                           👁️
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditPolicy(policy.id)}
//                           title="Edit"
//                         >
//                           ✏️
//                         </button>
//                         <button
//                           className="action-btn text-view"
//                           onClick={() => handleViewFormattedText(policy.id)}
//                           title="View Formatted Text"
//                         >
//                           📄
//                         </button>
//                         <button
//                           className={`action-btn ${policy.isActive ? 'deactivate' : 'activate'}`}
//                           onClick={() => handleToggleStatus(policy.id, policy.isActive)}
//                           title={policy.isActive ? 'Deactivate' : 'Activate'}
//                         >
//                           {policy.isActive ? '🔴' : '🟢'}
//                         </button>
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeletePolicy(policy.id)}
//                           title="Delete"
//                         >
//                           🗑️
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">
//                   <p>No booking policies found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all policies
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {policies.length} of {totalPolicies} policies
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }
//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>
//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>


//       {viewingPolicy && !isFetchingDetails && !showFormattedText && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Policy Details - {viewingPolicy.policyName}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Policy Name:</label>
//                   <span><strong>{viewingPolicy.policyName}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Cancellation Policy:</label>
//                   <span style={viewingPolicy.isInstant ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
//                     {viewingPolicy.cancellationPolicy}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Child Ticket Policy:</label>
//                   <span>{viewingPolicy.childTicketPolicy}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID Proof Requirement:</label>
//                   <span>{viewingPolicy.idProofRequirement}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Refund Percentage:</label>
//                   <span style={viewingPolicy.isInstant ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
//                     {viewingPolicy.isInstant ? '0% (No Refund)' : `${viewingPolicy.refundPercentage}%`}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Applicable For:</label>
//                   <span>{viewingPolicy.applicableFor?.join(', ') || 'All'}</span>
//                 </div>
//                 {viewingPolicy.description && (
//                   <div className="detail-row">
//                     <label>Description:</label>
//                     <span>{viewingPolicy.description}</span>
//                   </div>
//                 )}
//                 {viewingPolicy.termsAndConditions && (
//                   <div className="detail-row">
//                     <label>Terms & Conditions:</label>
//                     <span>{viewingPolicy.termsAndConditions}</span>
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingPolicy.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingPolicy.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingPolicy.isActive ? 'active' : 'inactive'}`}>
//                     {viewingPolicy.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//                 {viewingPolicy.isInstant && (
//                   <div className="detail-row" style={{ marginTop: '10px' }}>
//                     <div style={{ 
//                       background: '#fff3cd', 
//                       border: '1px solid #ffc107', 
//                       borderRadius: '4px', 
//                       padding: '10px',
//                       width: '100%',
//                       color: '#856404'
//                     }}>
//                       ⚠️ This is an Instant Booking Policy - No cancellations or refunds allowed
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showFormattedText && formattedText && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
//             <div className="modal-header">
//               <h3>Formatted Policy Text</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>×</button>
//             </div>
//             <div className="modal-body">
//               <pre style={{ 
//                 whiteSpace: 'pre-wrap', 
//                 fontFamily: 'monospace', 
//                 fontSize: '14px',
//                 lineHeight: '1.6',
//                 background: '#f5f5f5',
//                 padding: '15px',
//                 borderRadius: '8px'
//               }}>
//                 {formattedText}
//               </pre>
//             </div>
//             <div className="modal-footer">
//               <button 
//                 className="action-btn save" 
//                 onClick={() => {
//                   navigator.clipboard.writeText(formattedText);
//                   alert('Copied to clipboard!');
//                 }}
//               >
//                 Copy Text
//               </button>
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {creatingNew && (
//         <div className="modal-overlay" onClick={handleCancelCreate}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
//             <div className="modal-header">
//               <h3>Create New Booking Policy</h3>
//               <button className="modal-close-btn" onClick={handleCancelCreate}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Policy Type:*</label>
//                   <select
//                     name="policyType"
//                     value={newPolicyForm.policyType || 'standard'}
//                     onChange={handlePolicyTypeChange}
//                     className="form-control"
//                   >
//                     <option value="standard">Standard Booking Policy</option>
//                     <option value="instant">Instant Booking Policy (No Cancellation)</option>
//                   </select>
//                   <small style={{ color: newPolicyForm.policyType === 'instant' ? '#dc3545' : '#6c757d' }}>
//                     {newPolicyForm.policyType === 'instant' 
//                       ? '⚠️ Instant tickets cannot be cancelled and have 0% refund' 
//                       : 'Standard policy with cancellation and refund options'}
//                   </small>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Policy Name:*</label>
//                   <input
//                     type="text"
//                     name="policyName"
//                     value={newPolicyForm.policyName}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     placeholder={newPolicyForm.policyType === 'instant' ? 'Instant Bus Booking Policy' : 'E.g., Standard Booking Policy'}
//                     required
//                     disabled={newPolicyForm.policyType === 'instant'}
//                   />
//                   {newPolicyForm.policyType === 'instant' && (
//                     <small style={{ color: '#6c757d' }}>
//                       Policy name is automatically set for instant tickets
//                     </small>
//                   )}
//                 </div>
                
//                 <div className="form-group">
//                   <label>Cancellation Hours (before departure):*</label>
//                   <input
//                     type="number"
//                     name="cancellationHours"
//                     value={newPolicyForm.cancellationHours}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     min="0"
//                     step="1"
//                     disabled={newPolicyForm.policyType === 'instant'}
//                     style={newPolicyForm.policyType === 'instant' ? { background: '#e9ecef' } : {}}
//                   />
//                   <small>
//                     {newPolicyForm.policyType === 'instant' 
//                       ? 'Cancellation is not allowed for instant tickets' 
//                       : 'Cancellation allowed up to X hours before departure'}
//                   </small>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Child Age Limit:*</label>
//                   <input
//                     type="number"
//                     name="childAgeLimit"
//                     value={newPolicyForm.childAgeLimit}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     min="0"
//                     step="1"
//                   />
//                   <small>Children above this age need full ticket</small>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Refund Percentage:*</label>
//                   <input
//                     type="number"
//                     name="refundPercentage"
//                     value={newPolicyForm.refundPercentage}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     min="0"
//                     max="100"
//                     step="1"
//                     disabled={newPolicyForm.policyType === 'instant'}
//                     style={newPolicyForm.policyType === 'instant' ? { background: '#e9ecef' } : {}}
//                   />
//                   <small>
//                     {newPolicyForm.policyType === 'instant' 
//                       ? 'No refund for instant tickets' 
//                       : 'Percentage of refund for cancellations'}
//                   </small>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Applicable For:</label>
//                   <select
//                     multiple
//                     name="applicableFor"
//                     value={newPolicyForm.applicableFor}
//                     onChange={handleApplicableForChange}
//                     className="form-control"
//                     style={{ height: '100px' }}
//                   >
//                     <option value="all">All Bus Types</option>
//                     <option value="ac">AC Buses</option>
//                     <option value="non-ac">Non-AC Buses</option>
//                     <option value="sleeper">Sleeper Buses</option>
//                     <option value="seater">Seater Buses</option>
//                   </select>
//                   <small>Hold Ctrl to select multiple</small>
//                 </div>
                
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="requiredIdProof"
//                       checked={newPolicyForm.requiredIdProof}
//                       onChange={handleNewPolicyChange}
//                     />
//                     <span className="checkbox-text">Require Valid ID Proof</span>
//                   </label>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description:</label>
//                   <textarea
//                     name="description"
//                     value={newPolicyForm.description}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     rows="3"
//                     placeholder="Brief description of this policy"
//                     disabled={newPolicyForm.policyType === 'instant'}
//                     style={newPolicyForm.policyType === 'instant' ? { background: '#e9ecef' } : {}}
//                   />
//                   {newPolicyForm.policyType === 'instant' && (
//                     <small style={{ color: '#6c757d' }}>
//                       Description is automatically set for instant tickets
//                     </small>
//                   )}
//                 </div>
                
//                 <div className="form-group">
//                   <label>Terms & Conditions:</label>
//                   <textarea
//                     name="termsAndConditions"
//                     value={newPolicyForm.termsAndConditions}
//                     onChange={handleNewPolicyChange}
//                     className="form-control"
//                     rows="4"
//                     placeholder="Detailed terms and conditions..."
//                     disabled={newPolicyForm.policyType === 'instant'}
//                     style={newPolicyForm.policyType === 'instant' ? { background: '#e9ecef' } : {}}
//                   />
//                   {newPolicyForm.policyType === 'instant' && (
//                     <small style={{ color: '#6c757d' }}>
//                       Terms & Conditions are automatically set for instant tickets
//                     </small>
//                   )}
//                 </div>
                
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={newPolicyForm.isActive}
//                       onChange={handleNewPolicyChange}
//                     />
//                     <span className="checkbox-text">Activate Policy Immediately</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelCreate}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleCreatePolicy}>
//                 Create Policy
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {editingPolicy && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
//             <div className="modal-header">
//               <h3>Edit Booking Policy</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 {editForm.isInstant && (
//                   <div style={{ 
//                     background: '#fff3cd', 
//                     border: '1px solid #ffc107', 
//                     borderRadius: '4px', 
//                     padding: '10px',
//                     marginBottom: '15px',
//                     color: '#856404'
//                   }}>
//                     ⚠️ This is an Instant Booking Policy - Cancellation and Refund are disabled
//                   </div>
//                 )}
                
//                 <div className="form-group">
//                   <label>Policy Name:</label>
//                   <input
//                     type="text"
//                     name="policyName"
//                     value={editForm.policyName || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Cancellation Hours:</label>
//                   <input
//                     type="number"
//                     name="cancellationHours"
//                     value={editForm.cancellationHours || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     min="0"
//                     disabled={editForm.isInstant}
//                   />
//                   {editForm.isInstant && (
//                     <small style={{ color: '#dc3545' }}>Cancellation not allowed for instant tickets</small>
//                   )}
//                 </div>
                
//                 <div className="form-group">
//                   <label>Child Age Limit:</label>
//                   <input
//                     type="number"
//                     name="childAgeLimit"
//                     value={editForm.childAgeLimit || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     min="0"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Refund Percentage:</label>
//                   <input
//                     type="number"
//                     name="refundPercentage"
//                     value={editForm.refundPercentage || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     min="0"
//                     max="100"
//                     disabled={editForm.isInstant}
//                   />
//                   {editForm.isInstant && (
//                     <small style={{ color: '#dc3545' }}>No refund for instant tickets</small>
//                   )}
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description:</label>
//                   <textarea
//                     name="description"
//                     value={editForm.description || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     rows="3"
//                     disabled={editForm.isInstant}
//                   />
//                 </div>
                
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {isFetchingDetails && <SkeletonModal />}
//     </div>
//   );
// };

// export default BookingPolicyManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import {
  getBookingPolicies,
  getBookingPolicyById,
  createBookingPolicy,
  updateBookingPolicy,
  deleteBookingPolicy,
  toggleBookingPolicyStatus,
  getFormattedPolicyText,
} from '../../Services/Operations/ProductAPI';

/* ============================================================
 * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
 * ============================================================ */
const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
    refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
    x: 'M18 6 6 18 M6 6l12 12'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf, start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

const PrmCheckbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Policy Name</th>
          <th>Cancellation Hours</th>
          <th>Child Age Limit</th>
          <th>Refund %</th>
          <th>Applicable For</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const BookingPolicyManagement = () => {
  const { token } = useSelector(state => state.user);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingPolicy, setViewingPolicy] = useState(null);
  const [creatingNew, setCreatingNew] = useState(false);
  const [newPolicyForm, setNewPolicyForm] = useState({
    policyName: '',
    cancellationHours: 4,
    childAgeLimit: 5,
    requiredIdProof: true,
    refundPercentage: 100,
    applicableFor: ['all'],
    description: '',
    termsAndConditions: '',
    isActive: true,
    policyType: 'standard'
  });
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [formattedText, setFormattedText] = useState(null);
  const [showFormattedText, setShowFormattedText] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPolicies, setTotalPolicies] = useState(0);
  const [pageSize] = useState(10);

  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchPolicies();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm]);

  const extractHoursFromText = (text) => {
    if (!text) return 4;
    const match = text.match(/(\d+)\s*hours?/i);
    return match ? parseInt(match[1]) : 4;
  };

  const extractAgeFromText = (text) => {
    if (!text) return 5;
    const match = text.match(/above\s*(\d+)\s*years?/i);
    return match ? parseInt(match[1]) : 5;
  };

  const extractRefundFromText = (text) => {
    if (!text) return 100;
    const match = text.match(/(\d+)%/);
    return match ? parseInt(match[1]) : 100;
  };

  const fetchPolicies = async () => {
    try {
      setSearching(true);
      setLoading(true);
      const response = await getBookingPolicies(token, currentPage, pageSize, searchTerm);

      if (response && response.data) {
        const transformedPolicies = response.data.map((policy, index) => {
          const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
          
          return {
            id: policy.id || policy._id,
            serialNo: getSequentialNumber(index),
            policyName: policy.policyName || 'Untitled Policy',
            cancellationHours: policy.cancellationHours !== undefined && policy.cancellationHours !== null 
              ? policy.cancellationHours 
              : extractHoursFromText(policy.cancellationPolicy) || 4,
            childAgeLimit: policy.childAgeLimit !== undefined && policy.childAgeLimit !== null
              ? policy.childAgeLimit
              : extractAgeFromText(policy.childTicketPolicy) || 5,
            refundPercentage: policy.refundPercentage !== undefined && policy.refundPercentage !== null
              ? policy.refundPercentage
              : extractRefundFromText(policy.refundPolicy) || 100,
            applicableFor: policy.applicableFor || ['all'],
            isActive: policy.isActive !== undefined ? policy.isActive : true,
            status: policy.isActive ? 'Active' : 'Inactive',
            description: policy.description || '',
            termsAndConditions: policy.termsAndConditions || '',
            requiredIdProof: policy.idProofRequirement || 'Valid ID proof required',
            createdAt: policy.createdAt || new Date().toISOString(),
            updatedAt: policy.updatedAt || new Date().toISOString(),
            cancellationPolicy: policy.cancellationPolicy || `Cancellation allowed up to ${policy.cancellationHours || 4} hours before departure`,
            refundPolicy: policy.refundPolicy || `${policy.refundPercentage || 100}% refund applicable on valid cancellations`,
            childTicketPolicy: policy.childTicketPolicy || `Children above ${policy.childAgeLimit || 5} years need a full ticket`,
            idProofRequirementText: policy.idProofRequirement || 'Valid ID proof required for all passengers',
            isInstant: isInstant
          };
        });

        setPolicies(transformedPolicies);
        setTotalPages(response.totalPages || 1);
        setTotalPolicies(response.total || response.data.length);
      }
    } catch (err) {
      setError('Failed to fetch booking policies.');
      console.error('Error fetching policies:', err);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const handleViewPolicy = async (policyId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getBookingPolicyById(policyId, token);
      
      if (response.success) {
        const policy = response.data;
        const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
        
        setViewingPolicy({
          id: policy.id || policy._id,
          policyName: policy.policyName || 'Untitled Policy',
          cancellationPolicy: isInstant 
            ? 'Instant Ticket Can Not Be Cancel' 
            : (policy.cancellationPolicy || `Cancellation allowed up to ${policy.cancellationHours || 4} hours before departure`),
          childTicketPolicy: policy.childTicketPolicy || `Children above ${policy.childAgeLimit || 5} years need a full ticket`,
          idProofRequirement: policy.idProofRequirement || 'Valid ID proof required for all passengers',
          refundPercentage: policy.refundPercentage !== undefined && policy.refundPercentage !== null
            ? policy.refundPercentage
            : extractRefundFromText(policy.refundPolicy) || 100,
          applicableFor: policy.applicableFor || ['all'],
          description: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.description || ''),
          termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.termsAndConditions || ''),
          isActive: policy.isActive !== undefined ? policy.isActive : true,
          isInstant: isInstant,
          createdAt: policy.createdAt ? new Date(policy.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }) : 'N/A',
          updatedAt: policy.updatedAt ? new Date(policy.updatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }) : 'N/A'
        });
      } else {
        setError('Failed to fetch policy details.');
      }
    } catch (err) {
      console.error('Error fetching policy details:', err);
      setError('Failed to fetch policy details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleViewFormattedText = async (policyId) => {
    try {
      setIsFetchingDetails(true);
      const response = await getFormattedPolicyText(policyId, token);
      if (response.success) {
        setFormattedText(response.data.formattedText);
        setShowFormattedText(true);
      }
    } catch (err) {
      console.error('Error fetching formatted text:', err);
      setError('Failed to fetch formatted policy text.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditPolicy = async (policyId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getBookingPolicyById(policyId, token);
      
      if (response.success) {
        const policy = response.data;
        const isInstant = policy.policyName && policy.policyName.toLowerCase().includes('instant');
        
        setEditingPolicy(policy.id || policy._id);
        setEditForm({
          policyName: policy.policyName || '',
          cancellationHours: isInstant ? 0 : (policy.cancellationHours !== undefined && policy.cancellationHours !== null
            ? policy.cancellationHours
            : extractHoursFromText(policy.cancellationPolicy) || 4),
          childAgeLimit: policy.childAgeLimit !== undefined && policy.childAgeLimit !== null
            ? policy.childAgeLimit
            : extractAgeFromText(policy.childTicketPolicy) || 5,
          requiredIdProof: policy.idProofRequirement ? policy.idProofRequirement.includes('required') : true,
          refundPercentage: isInstant ? 0 : (policy.refundPercentage !== undefined && policy.refundPercentage !== null
            ? policy.refundPercentage
            : extractRefundFromText(policy.refundPolicy) || 100),
          applicableFor: policy.applicableFor || ['all'],
          description: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.description || ''),
          termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : (policy.termsAndConditions || ''),
          isActive: policy.isActive !== undefined ? policy.isActive : true,
          isInstant: isInstant
        });
      } else {
        setError('Failed to fetch policy details for editing.');
      }
    } catch (err) {
      console.error('Error fetching policy details for editing:', err);
      setError('Failed to fetch policy details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      
      const isInstant = editForm.policyName && editForm.policyName.toLowerCase().includes('instant');
      
      const updateData = {
        policyName: editForm.policyName,
        cancellationHours: isInstant ? 0 : parseInt(editForm.cancellationHours) || 0,
        childAgeLimit: parseInt(editForm.childAgeLimit) || 5,
        requiredIdProof: editForm.requiredIdProof,
        refundPercentage: isInstant ? 0 : parseInt(editForm.refundPercentage) || 0,
        applicableFor: editForm.applicableFor,
        description: isInstant ? 'Instant Ticket Can Not Be Cancel' : editForm.description,
        termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : editForm.termsAndConditions,
        isActive: editForm.isActive
      };

      const response = await updateBookingPolicy(editingPolicy, updateData, token);
      
      if (response.success) {
        setPolicies(prevPolicies =>
          prevPolicies.map(policy =>
            policy.id === editingPolicy ? {
              ...policy,
              policyName: response.data.policyName,
              cancellationHours: response.data.cancellationHours,
              childAgeLimit: response.data.childAgeLimit,
              refundPercentage: response.data.refundPercentage,
              status: response.data.isActive ? 'Active' : 'Inactive',
              isActive: response.data.isActive,
              isInstant: isInstant
            } : policy
          )
        );
        setEditingPolicy(null);
        setEditForm({});
        alert('Booking policy updated successfully!');
        fetchPolicies();
      } else {
        setError(response.message || 'Failed to update policy.');
      }
    } catch (err) {
      console.error('Error updating policy:', err);
      setError(err.response?.data?.message || 'Failed to update policy.');
      alert('Failed to update policy. Please try again.');
    }
  };

  const handleCreatePolicy = async () => {
    try {
      setError(null);
      
      const isInstant = newPolicyForm.policyType === 'instant';
      
      const createData = {
        policyName: isInstant ? 'Instant Bus Booking Policy' : newPolicyForm.policyName,
        cancellationHours: isInstant ? 0 : parseInt(newPolicyForm.cancellationHours) || 0,
        childAgeLimit: parseInt(newPolicyForm.childAgeLimit) || 5,
        requiredIdProof: newPolicyForm.requiredIdProof,
        refundPercentage: isInstant ? 0 : parseInt(newPolicyForm.refundPercentage) || 0,
        applicableFor: newPolicyForm.applicableFor,
        description: isInstant ? 'Instant Ticket Can Not Be Cancel' : newPolicyForm.description,
        termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : newPolicyForm.termsAndConditions,
        isActive: newPolicyForm.isActive
      };

      const response = await createBookingPolicy(createData, token);
      
      if (response.success) {
        setCreatingNew(false);
        setNewPolicyForm({
          policyName: '',
          cancellationHours: 4,
          childAgeLimit: 5,
          requiredIdProof: true,
          refundPercentage: 100,
          applicableFor: ['all'],
          description: '',
          termsAndConditions: '',
          isActive: true,
          policyType: 'standard'
        });
        alert('Booking policy created successfully!');
        fetchPolicies();
      } else {
        setError(response.message || 'Failed to create policy.');
      }
    } catch (err) {
      console.error('Error creating policy:', err);
      setError(err.response?.data?.message || 'Failed to create policy.');
      alert('Failed to create policy. Please try again.');
    }
  };

  const handleToggleStatus = async (policyId, currentStatus) => {
    if (window.confirm(`Are you sure you want to ${currentStatus ? 'deactivate' : 'activate'} this policy?`)) {
      try {
        const response = await toggleBookingPolicyStatus(policyId, token);
        if (response.success) {
          alert(`Policy ${response.message}`);
          fetchPolicies();
        }
      } catch (err) {
        console.error('Error toggling policy status:', err);
        alert('Failed to update policy status.');
      }
    }
  };

  const handleDeletePolicy = async (policyId) => {
    if (window.confirm('Are you sure you want to delete this policy?')) {
      try {
        const response = await deleteBookingPolicy(policyId, token);
        if (response.success) {
          alert('Policy deleted successfully!');
          fetchPolicies();
        }
      } catch (err) {
        console.error('Error deleting policy:', err);
        alert('Failed to delete policy.');
      }
    }
  };

  const handleCancelEdit = () => {
    setEditingPolicy(null);
    setEditForm({});
    setError(null);
  };

  const handleCancelCreate = () => {
    setCreatingNew(false);
    setNewPolicyForm({
      policyName: '',
      cancellationHours: 4,
      childAgeLimit: 5,
      requiredIdProof: true,
      refundPercentage: 100,
      applicableFor: ['all'],
      description: '',
      termsAndConditions: '',
      isActive: true,
      policyType: 'standard'
    });
    setError(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleNewPolicyChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewPolicyForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePolicyTypeChange = (e) => {
    const value = e.target.value;
    const isInstant = value === 'instant';
    
    setNewPolicyForm(prev => ({
      ...prev,
      policyType: value,
      policyName: isInstant ? 'Instant Bus Booking Policy' : prev.policyName,
      cancellationHours: isInstant ? 0 : prev.cancellationHours,
      refundPercentage: isInstant ? 0 : prev.refundPercentage,
      description: isInstant ? 'Instant Ticket Can Not Be Cancel' : prev.description,
      termsAndConditions: isInstant ? 'Instant Ticket Can Not Be Cancel' : prev.termsAndConditions
    }));
  };

  const handleApplicableForChange = (e) => {
    const options = e.target.options;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }
    setNewPolicyForm(prev => ({
      ...prev,
      applicableFor: selected
    }));
  };

  const closeViewModal = () => {
    setViewingPolicy(null);
    setShowFormattedText(false);
    setFormattedText(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    fetchPolicies();
  };

  const handleExportCSV = () => {
    if (policies.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['No.', 'Policy Name', 'Cancellation Hours', 'Child Age Limit', 'Refund %', 'Applicable For', 'Status', 'Created At'];
    const csvData = policies.map(policy => [
      policy.serialNo,
      policy.policyName,
      policy.isInstant ? 'No Cancellation' : `${policy.cancellationHours} hours`,
      `Above ${policy.childAgeLimit} years`,
      policy.isInstant ? '0%' : `${policy.refundPercentage}%`,
      policy.applicableFor.join(', '),
      policy.status,
      new Date(policy.createdAt).toLocaleDateString()
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `booking-policies-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    alert('CSV exported successfully!');
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading && policies.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>
        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>
        <SkeletonTable />
        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }


  return (
    <div className="prm-page">
      {/* ============================== HERO ============================== */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="shield" size={13} /> Policy Insights</span>
          <h1>Booking Policy Management</h1>
          <p>Define cancellation rules, refund percentages and child ticket policies for your buses.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search policies by name…"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={16} />
          </button>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleExportCSV} title="Export CSV">
            <Icon name="list" size={16} />
          </button>
          <button className="prm-add-btn" onClick={() => setCreatingNew(true)}>
            <span className="plus"><Icon name="plus" size={14} /></span> Add Policy
          </button>
        </div>
      </div>

      {error && (
        <div className="prm-callout rose" style={{ marginTop: 20, background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
          <Icon name="info" size={18} />
          <div>
            <strong>Error</strong>
            <span>{error}</span>
          </div>
        </div>
      )}

      {/* ============================== STATS ============================== */}
      <div className="prm-stats">
        <StatCard icon="shield" tone="indigo" label="Total Policies" value={totalPolicies} hint="All booking policies" delay={80} />
        <StatCard icon="check" tone="green" label="Active Policies" value={policies.filter(p => p.status === 'Active').length} hint="Active policies" delay={160} />
        <StatCard icon="x" tone="amber" label="Inactive Policies" value={policies.filter(p => p.status === 'Inactive').length} hint="Inactive policies" delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={policies.length} hint="Policies on this page" delay={320} />
      </div>

      {/* ============================== TOOLBAR ============================== */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <span className="prm-tag navy"><Icon name="shield" size={12} /> Policy Rules</span>
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{policies.length}</b> of {totalPolicies}</span>
          {searching && <span style={{ color: 'var(--amber-deep)', fontSize: 12 }}>· searching…</span>}
        </div>
      </div>

      {/* ============================== TABLE ============================== */}
      {policies.length === 0 ? (
        <div className="prm-empty">
          <div className="icon"><Icon name={searchTerm ? 'search' : 'shield'} size={44} /></div>
          <h3>{searchTerm ? 'No policies match your search' : 'No booking policies yet'}</h3>
          <p>{searchTerm ? 'Try a different search term.' : 'Create your first booking policy.'}</p>
          {searchTerm && <button className="prm-btn ghost" onClick={handleRefresh}>Clear search</button>}
        </div>
      ) : (
        <div className="prm-table-wrap">
          <table className="prm-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Policy Name</th>
                <th>Cancellation</th>
                <th>Child Age</th>
                <th>Refund</th>
                <th>Applicable For</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {policies.map((policy, i) => (
                <tr key={policy.id} style={{ animationDelay: `${i * 40}ms` }}>
                  <td><b style={{ color: 'var(--muted)' }}>{policy.serialNo}</b></td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <input
                        type="text"
                        name="policyName"
                        value={editForm.policyName || ''}
                        onChange={handleInputChange}
                        className="prm-input"
                        style={{ padding: '6px 10px', fontSize: 13 }}
                      />
                    ) : (
                      <div>
                        <div className="name">{policy.policyName}</div>
                        {policy.isInstant && (
                          <div className="sub">
                            <span className="prm-tag" style={{ background: '#fee2e2', color: '#991b1b' }}>⚡ No Cancellation</span>
                          </div>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <input
                        type="number"
                        name="cancellationHours"
                        value={editForm.cancellationHours || ''}
                        onChange={handleInputChange}
                        className="prm-input"
                        min="0"
                        disabled={editForm.isInstant}
                        style={{ padding: '6px 10px', fontSize: 13, width: 90 }}
                      />
                    ) : policy.isInstant ? (
                      <span className="prm-tag" style={{ background: 'var(--rose-soft)', color: 'var(--rose)' }}>No Cancellation</span>
                    ) : (
                      <span>{policy.cancellationHours} hours</span>
                    )}
                  </td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <input
                        type="number"
                        name="childAgeLimit"
                        value={editForm.childAgeLimit || ''}
                        onChange={handleInputChange}
                        className="prm-input"
                        min="0"
                        style={{ padding: '6px 10px', fontSize: 13, width: 80 }}
                      />
                    ) : (
                      `Above ${policy.childAgeLimit} yrs`
                    )}
                  </td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <input
                        type="number"
                        name="refundPercentage"
                        value={editForm.refundPercentage || ''}
                        onChange={handleInputChange}
                        className="prm-input"
                        min="0"
                        max="100"
                        disabled={editForm.isInstant}
                        style={{ padding: '6px 10px', fontSize: 13, width: 80 }}
                      />
                    ) : policy.isInstant ? (
                      <span className="prm-tag" style={{ background: 'var(--rose-soft)', color: 'var(--rose)' }}>0%</span>
                    ) : (
                      <span className="prm-tag teal">{policy.refundPercentage}%</span>
                    )}
                  </td>
                  <td>{policy.applicableFor?.join(', ') || 'All'}</td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <PrmCheckbox
                        label={editForm.isActive ? 'Active' : 'Inactive'}
                        checked={editForm.isActive || false}
                        onChange={handleInputChange}
                      />
                    ) : (
                      <span className={`prm-status ${policy.status ? policy.status.toLowerCase() : 'inactive'}`}>
                        {policy.status}
                      </span>
                    )}
                  </td>
                  <td>
                    {editingPolicy === policy.id ? (
                      <div className="prm-row-actions">
                        <button className="prm-btn primary sm icon-only" onClick={handleSaveEdit} disabled={isFetchingDetails} title="Save" aria-label="Save"><Icon name="check" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={handleCancelEdit} title="Cancel" aria-label="Cancel"><Icon name="x" size={14} /></button>
                      </div>
                    ) : (
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewPolicy(policy.id)} title="View Details"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleEditPolicy(policy.id)} title="Edit"><Icon name="edit" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleViewFormattedText(policy.id)} title="View Formatted Text"><Icon name="file" size={14} /></button>
                        <button className={`prm-btn ${policy.isActive ? 'ghost' : 'primary'} sm icon-only`} onClick={() => handleToggleStatus(policy.id, policy.isActive)} title={policy.isActive ? 'Deactivate' : 'Activate'}><Icon name={policy.isActive ? 'x' : 'check'} size={14} /></button>
                        <button className="prm-btn danger sm icon-only" onClick={() => handleDeletePolicy(policy.id)} title="Delete"><Icon name="trash" size={14} /></button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ============================== PAGINATION ============================== */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22, flexWrap: 'wrap' }}>
          <button className="prm-btn ghost" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
          <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button className="prm-btn ghost" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}

      {/* ============================================================
       * VIEW POLICY MODAL — Modern redesign
       * ============================================================ */}
      {viewingPolicy && !isFetchingDetails && !showFormattedText && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
            <div className="prm-modal-head">
              <h3>{viewingPolicy.policyName}</h3>
              <p><Icon name="shield" size={14} /> {viewingPolicy.isActive ? 'Active' : 'Inactive'} · {viewingPolicy.isInstant ? 'Instant Policy' : 'Standard Policy'}</p>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-modal-body">
              <div className="prm-info-grid">
                <div className="prm-info">
                  <div className="l">Cancellation</div>
                  <div className="v">{viewingPolicy.isInstant ? 'Not allowed' : `${viewingPolicy.cancellationHours} hours`}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Refund</div>
                  <div className="v">{viewingPolicy.isInstant ? '0%' : `${viewingPolicy.refundPercentage}%`}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Child Age</div>
                  <div className="v">Above {viewingPolicy.childAgeLimit} yrs</div>
                </div>
                <div className="prm-info">
                  <div className="l">Status</div>
                  <div className="v">
                    <span className={`prm-status ${viewingPolicy.isActive ? 'active' : 'inactive'}`}>
                      {viewingPolicy.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="prm-section-title">Policies</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                  <div className="l">Cancellation Policy</div>
                  <div className="v" style={{ fontSize: 13, fontWeight: 500, color: viewingPolicy.isInstant ? 'var(--rose)' : undefined }}>
                    {viewingPolicy.cancellationPolicy}
                  </div>
                </div>
                <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                  <div className="l">Child Ticket Policy</div>
                  <div className="v" style={{ fontSize: 13, fontWeight: 500 }}>{viewingPolicy.childTicketPolicy}</div>
                </div>
                <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                  <div className="l">ID Proof Requirement</div>
                  <div className="v" style={{ fontSize: 13, fontWeight: 500 }}>{viewingPolicy.idProofRequirement}</div>
                </div>
                <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                  <div className="l">Applicable For</div>
                  <div className="v" style={{ fontSize: 13, fontWeight: 500 }}>{viewingPolicy.applicableFor?.join(', ') || 'All'}</div>
                </div>
              </div>

              {viewingPolicy.description && viewingPolicy.description !== 'Instant Ticket Can Not Be Cancel' && (
                <>
                  <div className="prm-section-title">Description</div>
                  <div className="prm-info" style={{ marginBottom: 22 }}>
                    <div className="v" style={{ fontSize: 13, fontWeight: 500 }}>{viewingPolicy.description}</div>
                  </div>
                </>
              )}

              {viewingPolicy.termsAndConditions && viewingPolicy.termsAndConditions !== 'Instant Ticket Can Not Be Cancel' && (
                <>
                  <div className="prm-section-title">Terms & Conditions</div>
                  <div className="prm-info" style={{ marginBottom: 22 }}>
                    <div className="v" style={{ fontSize: 13, fontWeight: 500, whiteSpace: 'pre-wrap' }}>{viewingPolicy.termsAndConditions}</div>
                  </div>
                </>
              )}

              {viewingPolicy.isInstant && (
                <div className="prm-callout amber" style={{ marginTop: 12 }}>
                  <Icon name="info" size={18} />
                  <div>
                    <strong>Instant Booking Policy</strong>
                    <span>No cancellations or refunds allowed for instant tickets.</span>
                  </div>
                </div>
              )}

              <div className="prm-section-title" style={{ marginTop: 22 }}>Metadata</div>
              <div className="prm-info-grid">
                <div className="prm-info"><div className="l">Created</div><div className="v">{viewingPolicy.createdAt}</div></div>
                <div className="prm-info"><div className="l">Last Updated</div><div className="v">{viewingPolicy.updatedAt}</div></div>
              </div>
            </div>

            <div className="prm-modal-foot">
              <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={closeViewModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * FORMATTED TEXT MODAL — Modern redesign
       * ============================================================ */}
      {showFormattedText && formattedText && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 640 }}>
            <div className="prm-modal-head">
              <h3>Formatted Policy Text</h3>
              <p><Icon name="file" size={14} /> Copy-ready policy text</p>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>
            <div className="prm-modal-body">
              <pre style={{
                whiteSpace: 'pre-wrap',
                fontFamily: 'monospace',
                fontSize: 13,
                lineHeight: 1.6,
                background: '#f6f8fc',
                padding: 18,
                borderRadius: 14,
                border: '1px solid var(--line)',
                margin: 0,
                color: 'var(--navy-900)'
              }}>
                {formattedText}
              </pre>
            </div>
            <div className="prm-modal-foot" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button
                className="prm-btn teal"
                style={{ padding: '11px 22px' }}
                onClick={() => {
                  navigator.clipboard.writeText(formattedText);
                  alert('Copied to clipboard!');
                }}
              >
                <Icon name="file" size={15} /> Copy Text
              </button>
              <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={closeViewModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * CREATE MODAL — Modern redesign
       * ============================================================ */}
      {creatingNew && (
        <div className="prm-overlay" onClick={handleCancelCreate}>
          <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={24} /></span>
                <div>
                  <h3>Create New Booking Policy</h3>
                  <p>Define rules for cancellations, refunds and child tickets.</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={handleCancelCreate}>×</button>
            </div>

            <div className="prm-form-body">
              {/* 1 — Policy Type */}
              <FormSection n="1" title="Policy Type" hint="Choose standard or instant booking policy." delay={40}>
                {newPolicyForm.policyType === 'instant' && (
                  <div className="prm-callout amber" style={{ marginBottom: 14 }}>
                    <Icon name="info" size={18} />
                    <div>
                      <strong>Instant Booking Policy</strong>
                      <span>Instant tickets cannot be cancelled and have 0% refund.</span>
                    </div>
                  </div>
                )}
                <div className="prm-fgrid">
                  <Field label="Policy Type" required full>
                    <select
                      name="policyType"
                      value={newPolicyForm.policyType || 'standard'}
                      onChange={handlePolicyTypeChange}
                      className="prm-input prm-select"
                    >
                      <option value="standard">Standard Booking Policy</option>
                      <option value="instant">Instant Booking Policy (No Cancellation)</option>
                    </select>
                  </Field>
                  <Field label="Policy Name" required full>
                    <input
                      type="text"
                      name="policyName"
                      value={newPolicyForm.policyName}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      placeholder={newPolicyForm.policyType === 'instant' ? 'Instant Bus Booking Policy' : 'E.g., Standard Booking Policy'}
                      disabled={newPolicyForm.policyType === 'instant'}
                    />
                  </Field>
                </div>
              </FormSection>

              {/* 2 — Rules */}
              <FormSection n="2" title="Cancellation & Refund" hint="Configure rules for cancellations." delay={80}>
                <div className="prm-fgrid">
                  <Field label="Cancellation Hours (before departure)" required note="Cancellation allowed up to X hours before departure">
                    <input
                      type="number"
                      name="cancellationHours"
                      value={newPolicyForm.cancellationHours}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      min="0"
                      step="1"
                      disabled={newPolicyForm.policyType === 'instant'}
                    />
                  </Field>
                  <Field label="Refund Percentage" required note="Percentage of refund for cancellations">
                    <input
                      type="number"
                      name="refundPercentage"
                      value={newPolicyForm.refundPercentage}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      min="0"
                      max="100"
                      step="1"
                      disabled={newPolicyForm.policyType === 'instant'}
                    />
                  </Field>
                  <Field label="Child Age Limit" required full note="Children above this age need full ticket">
                    <input
                      type="number"
                      name="childAgeLimit"
                      value={newPolicyForm.childAgeLimit}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      min="0"
                      step="1"
                    />
                  </Field>
                </div>
              </FormSection>

              {/* 3 — Applicability */}
              <FormSection n="3" title="Applicability" hint="Which bus types does this policy apply to?" delay={120}>
                <div className="prm-fgrid">
                  <Field label="Applicable For" full note="Hold Ctrl / Cmd to select multiple">
                    <select
                      multiple
                      name="applicableFor"
                      value={newPolicyForm.applicableFor}
                      onChange={handleApplicableForChange}
                      className="prm-input prm-select"
                      style={{ height: 120 }}
                    >
                      <option value="all">All Bus Types</option>
                      <option value="ac">AC Buses</option>
                      <option value="non-ac">Non-AC Buses</option>
                      <option value="sleeper">Sleeper Buses</option>
                      <option value="seater">Seater Buses</option>
                    </select>
                  </Field>
                </div>
                <div style={{ marginTop: 14 }}>
                  <PrmCheckbox
                    label="Require Valid ID Proof"
                    checked={newPolicyForm.requiredIdProof}
                    onChange={handleNewPolicyChange}
                  />
                </div>
                <div style={{ marginTop: 14 }}>
                  <PrmCheckbox
                    label="Activate Policy Immediately"
                    checked={newPolicyForm.isActive}
                    onChange={handleNewPolicyChange}
                  />
                </div>
              </FormSection>

              {/* 4 — Content */}
              <FormSection n="4" title="Policy Content" hint="Additional details (optional)." delay={160}>
                <div className="prm-fgrid">
                  <Field label="Description" full>
                    <textarea
                      name="description"
                      value={newPolicyForm.description}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      rows="3"
                      placeholder="Brief description of this policy"
                      disabled={newPolicyForm.policyType === 'instant'}
                    />
                  </Field>
                  <Field label="Terms & Conditions" full>
                    <textarea
                      name="termsAndConditions"
                      value={newPolicyForm.termsAndConditions}
                      onChange={handleNewPolicyChange}
                      className="prm-input"
                      rows="4"
                      placeholder="Detailed terms and conditions…"
                      disabled={newPolicyForm.policyType === 'instant'}
                    />
                  </Field>
                </div>
              </FormSection>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={handleCancelCreate}>Cancel</button>
                <button className="prm-btn primary" onClick={handleCreatePolicy}>
                  <Icon name="check" size={16} /> Create Policy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * EDIT MODAL — Modern redesign
       * ============================================================ */}
      {editingPolicy && !isFetchingDetails && (
        <div className="prm-overlay" onClick={handleCancelEdit}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={24} /></span>
                <div>
                  <h3>Edit Booking Policy</h3>
                  <p>{editForm.policyName}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={handleCancelEdit}>×</button>
            </div>

            <div className="prm-form-body">
              {editForm.isInstant && (
                <div className="prm-callout amber">
                  <Icon name="info" size={18} />
                  <div>
                    <strong>Instant Booking Policy</strong>
                    <span>Cancellation and refund are disabled for this policy.</span>
                  </div>
                </div>
              )}

              <FormSection n="1" title="Policy Details" hint="Edit the policy fields below." delay={40}>
                <div className="prm-fgrid">
                  <Field label="Policy Name" required full>
                    <input
                      type="text"
                      name="policyName"
                      value={editForm.policyName || ''}
                      onChange={handleInputChange}
                      className="prm-input"
                    />
                  </Field>
                  <Field label="Cancellation Hours" note={editForm.isInstant ? 'Not applicable for instant tickets' : ''}>
                    <input
                      type="number"
                      name="cancellationHours"
                      value={editForm.cancellationHours || ''}
                      onChange={handleInputChange}
                      className="prm-input"
                      min="0"
                      disabled={editForm.isInstant}
                    />
                  </Field>
                  <Field label="Refund Percentage" note={editForm.isInstant ? 'No refund for instant tickets' : ''}>
                    <input
                      type="number"
                      name="refundPercentage"
                      value={editForm.refundPercentage || ''}
                      onChange={handleInputChange}
                      className="prm-input"
                      min="0"
                      max="100"
                      disabled={editForm.isInstant}
                    />
                  </Field>
                  <Field label="Child Age Limit" full>
                    <input
                      type="number"
                      name="childAgeLimit"
                      value={editForm.childAgeLimit || ''}
                      onChange={handleInputChange}
                      className="prm-input"
                      min="0"
                    />
                  </Field>
                  <Field label="Description" full>
                    <textarea
                      name="description"
                      value={editForm.description || ''}
                      onChange={handleInputChange}
                      className="prm-input"
                      rows="3"
                      disabled={editForm.isInstant}
                    />
                  </Field>
                </div>
                <div style={{ marginTop: 14 }}>
                  <PrmCheckbox
                    label="Active"
                    checked={editForm.isActive || false}
                    onChange={handleInputChange}
                  />
                </div>
              </FormSection>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={handleCancelEdit}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit}>
                  <Icon name="check" size={16} /> Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Loading skeleton while fetching details */}
      {isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingPolicyManagement;